const getBrandName = () => {
  if (window.location.hostname.includes('tellent')) return 'tellent';
  return 'recruitee';
};

document.documentElement.setAttribute('product-brand', getBrandName());